import { render } from "./RegisterTag.vue?vue&type=template&id=9cf5af48&scoped=true"
import script from "./RegisterTag.vue?vue&type=script&lang=js"
export * from "./RegisterTag.vue?vue&type=script&lang=js"

import "./RegisterTag.vue?vue&type=style&index=0&id=9cf5af48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf5af48"]])

export default __exports__